module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "loading"
  }, [_vm._c('span', [_vm._v(_vm._s(_vm.displaytext))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "inner"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/brain.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49eb1f74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LoadingIndicator.vue
// module id = 659
// module chunks = 1